// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes w8fqmp1 {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.w8fqmp0 {
  position: relative;
}
.w8fqmp2 {
  position: absolute;
  background: linear-gradient(90deg,rgba(234, 234, 234, 0) 0%,#eaeaea 67.71%,rgba(234, 234, 234, 0) 100%);
  animation: w8fqmp1 1.8s ease-in-out infinite;
  animation-timing-function: cubic-bezier(0.7, -0.4, 0.4, 1.4);
}
.w8fqmp3 {
  position: relative;
  overflow: hidden;
  background-color: #F7F7F7;
}
.w8fqmp7 {
  width: var(--w8fqmp4);
}
.w8fqmpd {
  height: var(--w8fqmpa);
}
.w8fqmpj {
  aspect-ratio: var(--w8fqmpg);
}
.w8fqmpp {
  border-radius: var(--w8fqmpm);
}
@media screen and (min-width: 768px)  {
  .w8fqmp8 {
    width: var(--w8fqmp5);
  }
  .w8fqmpe {
    height: var(--w8fqmpb);
  }
  .w8fqmpk {
    aspect-ratio: var(--w8fqmph);
  }
  .w8fqmpq {
    border-radius: var(--w8fqmpn);
  }
}
@media screen and (min-width: 1024px)  {
  .w8fqmp9 {
    width: var(--w8fqmp6);
  }
  .w8fqmpf {
    height: var(--w8fqmpc);
  }
  .w8fqmpl {
    aspect-ratio: var(--w8fqmpi);
  }
  .w8fqmpr {
    border-radius: var(--w8fqmpo);
  }
}`, "",{"version":3,"sources":["webpack://./../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uGAAuG;EACvG,4CAA4C;EAC5C,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["@keyframes w8fqmp1 {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n.w8fqmp0 {\n  position: relative;\n}\n.w8fqmp2 {\n  position: absolute;\n  background: linear-gradient(90deg,rgba(234, 234, 234, 0) 0%,#eaeaea 67.71%,rgba(234, 234, 234, 0) 100%);\n  animation: w8fqmp1 1.8s ease-in-out infinite;\n  animation-timing-function: cubic-bezier(0.7, -0.4, 0.4, 1.4);\n}\n.w8fqmp3 {\n  position: relative;\n  overflow: hidden;\n  background-color: #F7F7F7;\n}\n.w8fqmp7 {\n  width: var(--w8fqmp4);\n}\n.w8fqmpd {\n  height: var(--w8fqmpa);\n}\n.w8fqmpj {\n  aspect-ratio: var(--w8fqmpg);\n}\n.w8fqmpp {\n  border-radius: var(--w8fqmpm);\n}\n@media screen and (min-width: 768px)  {\n  .w8fqmp8 {\n    width: var(--w8fqmp5);\n  }\n  .w8fqmpe {\n    height: var(--w8fqmpb);\n  }\n  .w8fqmpk {\n    aspect-ratio: var(--w8fqmph);\n  }\n  .w8fqmpq {\n    border-radius: var(--w8fqmpn);\n  }\n}\n@media screen and (min-width: 1024px)  {\n  .w8fqmp9 {\n    width: var(--w8fqmp6);\n  }\n  .w8fqmpf {\n    height: var(--w8fqmpc);\n  }\n  .w8fqmpl {\n    aspect-ratio: var(--w8fqmpi);\n  }\n  .w8fqmpr {\n    border-radius: var(--w8fqmpo);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
